<template>
    <div :class="isAfert ? 'entity-compare-after' : ''">
        <div>
            <div class="tab-heading">
                <h2>{{ t('consultants::stepper.title.main_details') }}</h2>
            </div>

            <div class="tab-sub-heading">
                <h3>{{ t('consultants::form.title.general_information') }}</h3>
            </div>
            <div class="notification-field gmc_number">
                <label class="label"
                    >{{ t('consultants::form.label.gmc_number') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.gmc_number }}</div>
            </div>
            <div class="notification-field company_name">
                <label class="label"
                    >{{ t('consultants::form.label.company_name') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.company_name }}</div>
            </div>
            <div class="notification-field surname">
                <label class="label"
                    >{{ t('consultants::form.label.surname') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.surname }}</div>
            </div>
            <div class="notification-field forename">
                <label class="label"
                    >{{ t('consultants::form.label.forename') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.forename }}</div>
            </div>
            <div class="notification-field address">
                <label class="label"
                    >{{ t('consultants::form.label.address') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.address }}</div>
            </div>
            <div class="notification-field post_code">
                <label class="label"
                    >{{ t('consultants::form.label.post_code') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.post_code }}</div>
            </div>

            <div class="tab-sub-heading">
                <h3>{{ t('consultants::form.title.contact_details') }}</h3>
            </div>
            <div class="notification-field phone">
                <label class="label"
                    >{{ t('consultants::form.label.phone') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.phone }}</div>
            </div>
            <div class="notification-field fax">
                <label class="label">{{ t('consultants::form.label.fax') }}</label>
                <div class="value">{{ store.fax }}</div>
            </div>
            <div class="notification-field email">
                <label class="label"
                    >{{ t('consultants::form.label.email') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.email }}</div>
            </div>
            <div class="notification-field can_be_sent_letters">
                <label class="label">{{ t('consultants::form.label.letters_sent') }}</label>
                <div class="value">{{ getStatus(store.can_be_sent_letters) }}</div>
            </div>

            <div class="tab-sub-heading">
                <h3>{{ t('consultants::form.title.credentials') }}</h3>
            </div>
            <div class="notification-field is_registered">
                <label class="label">{{ t('consultants::form.label.registered') }}</label>
                <div class="value">{{ getStatus(store.is_registered) }}</div>
            </div>
            <div class="notification-field is_rcop_member">
                <label class="label">{{ t('consultants::form.label.rcop_member') }}</label>
                <div class="value">{{ getStatus(store.is_rcop_member) }}</div>
            </div>
        </div>
        <div>
            <div class="tab-heading">
                <h2>{{ t('consultants::stepper.title.out_hours') }}</h2>
            </div>
            <div class="notification-field out_of_hours_contact_name">
                <label class="label">{{ t('consultants::form.label.name') }} </label>
                <div class="value">{{ store.out_of_hours_contact_name }}</div>
            </div>
            <div class="notification-field out_of_hours_contact_phone">
                <label class="label">{{ t('consultants::form.label.phone') }} </label>
                <div class="value">{{ store.out_of_hours_contact_phone }}</div>
            </div>
            <div class="notification-field out_of_hours_contact_fax">
                <label class="label">{{ t('consultants::form.label.fax') }} </label>
                <div class="value">{{ store.out_of_hours_contact_fax }}</div>
            </div>
            <div class="notification-field out_of_hours_contact_email">
                <label class="label">{{ t('consultants::form.label.email') }} </label>
                <div class="value">{{ store.out_of_hours_contact_email }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotificationConsultantApprovalRequestForm',
    components: {},
    props: {
        store: {
            type: Object,
            required: true,
        },
        isAfert: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        updatedProps() {
            return this.$store.state.notification_consultant.updatedProps.map((x) => x.replace('.', '-'));
        },
    },
    watch: {
        updatedProps() {
            this.setActiveItems();
        },
    },
    mounted() {
        this.setActiveItems();
    },
    created() {},
    methods: {
        getStatus(status) {
            return status ? 'True' : 'False';
        },
        setActiveItems() {
            if (!this.updatedProps.length) {
                return;
            }
            this.updatedProps.forEach((props) => {
                const field = this.$el.querySelector(`.${props}`);
                // console.warn('props', field ? field : props);
                if (field) {
                    field.classList.add('updated');
                }
            });
        },
    },
};
</script>
